import { Label } from '@/components/ui/label';
import { getCriteriaForType } from '@/utils/criteria';

export const CriteriaSelector = ({ selectedCriteria, onChange, propertyType = 'Appartement' }) => {
  const categories = getCriteriaForType(propertyType);

  const toggleCriterion = (category, value) => {
    const current = selectedCriteria[category] || [];
    const newCriteria = { ...selectedCriteria };
    
    if (current.includes(value)) {
      newCriteria[category] = current.filter(v => v !== value);
    } else {
      newCriteria[category] = [...current, value];
    }
    
    onChange(newCriteria);
  };

  return (
    <div className="space-y-6">
      {Object.entries(categories).map(([categoryKey, category]) => (
        <div key={categoryKey} className="bg-white border border-gray-200 rounded-xl p-4">
          <Label className="text-base font-bold text-gray-800 mb-3 block">
            {category.label}
          </Label>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {category.options.map((option) => {
              const isChecked = (selectedCriteria[categoryKey] || []).includes(option.value);
              return (
                <label
                  key={option.value}
                  className={`flex items-center gap-2 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                    isChecked
                      ? 'border-blue-600 bg-blue-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => toggleCriterion(categoryKey, option.value)}
                    className="w-4 h-4 rounded"
                  />
                  <span className={`text-sm ${
                    isChecked ? 'font-semibold text-blue-800' : 'text-gray-700'
                  }`}>
                    {option.label}
                  </span>
                </label>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
